export default [{
    value: {
        value: 'pending',
        id: 1
    },
    label: 'Pendiente',
},
{
    value: {
        value: 'active',
        id: 2
    },
    label: 'Activo',
}, {
    value: {
        value: 'recovery',
        id: 3
    },
    label: 'Recupero',
}, {
    value: {
        value: 'blocked',
        id: 4
    },
    label: 'Bloqueado',
}, {
    value: {
        value: 'inactive',
        id: 5
    },
    label: 'Inactivo',
}
];
